
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/multistreaming",
      function () {
        return require("private-next-pages/multistreaming.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/multistreaming"])
      });
    }
  